import { apiCall } from "./common/oauth.service"
import config from "../config/application"
class permissionService {
  validPermission(transactionCode, username, systemCode, action) {
    const jsonData = {
      transactionCode: transactionCode,
      username: username,
      systemCode: systemCode,
      action: action,
    }

    const url = `${config.data.security.permission.url}`
    return apiCall("post", url, jsonData)
  }
}

export default new permissionService()
